import { render, staticRenderFns } from "./vendor-details.vue?vue&type=template&id=fa77e03c&scoped=true&"
import script from "./vendor-details.vue?vue&type=script&lang=js&"
export * from "./vendor-details.vue?vue&type=script&lang=js&"
import style0 from "./vendor-details.vue?vue&type=style&index=0&id=fa77e03c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa77e03c",
  null
  
)

export default component.exports